module.exports = __webpack_public_path__ + "static/media/scheme.4fc289ae.svg";